import { z } from 'zod'

import { isoDateTime } from '../lib/date'
import { clinicIdSchema } from './clinic'

export const blockedSlotSchema = z.object({
  id: z.uuid(),
  staffId: z.uuid(),
  createdBy: z.uuid().nullable(),
  clinicId: clinicIdSchema.nullable(),
  startTime: isoDateTime,
  endTime: isoDateTime,
  note: z.string().nullable(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
})

export type BlockedSlot = z.output<typeof blockedSlotSchema>
